import React from "react";

const Footer = () => {

    return (
        <footer>
            <a href="https://github.com/korvus/devinator">Github</a>
            <a href="https://simonertel.net">Write me</a>
            <a href="https://simon.gallery/shop">T-shirts</a>
        </footer>
    )

}

export default Footer;